import { render, staticRenderFns } from "./FormularioUsuario.vue?vue&type=template&id=36f476bf"
import script from "./FormularioUsuario.vue?vue&type=script&lang=js"
export * from "./FormularioUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports